// Intentionally empty.
// Next.js 15 resolves this file convention during development.
